import { GET } from '../../common/common.service'
import endpointConsumption from './endpoints'

const ConsumptionService = {
  getAllConsumption: async ({ filter, sort, limit, skip }) =>
    GET(endpointConsumption.LOAD_CONSUMPTION({ filter, sort, limit, skip })),
  getByOwnStationConsumption: async ({
    id,
    initDate,
    finishDate,
    filter,
    sort,
    limit,
    skip,
  }) =>
    GET(
      endpointConsumption.BY_OWN_STATION_CONSUMPTION({
        id,
        initDate,
        finishDate,
        filter,
        sort,
        limit,
        skip,
      }),
    ),
  getAllPrediction: async ({ filter, sort, limit, skip }) =>
    GET(endpointConsumption.LOAD_PREDICTION({ filter, sort, limit, skip })),
  getByOwnStationPrediction: async ({
    id,
    initDate,
    finishDate,
    filter,
    sort,
    limit,
    skip,
  }) =>
    GET(
      endpointConsumption.BY_OWN_STATION_PREDICTION({
        id,
        initDate,
        finishDate,
        filter,
        sort,
        limit,
        skip,
      }),
    ),
}

export default ConsumptionService
